module.exports = __webpack_public_path__ + "static/media/logo.fa0973db.svg";